import { getUrlByENV } from '@x-tech/fe-utils/dist/xinchao';
import { getClientId } from '@x-tech/fe-utils/dist/misc';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function sendByXhr(url, data) {
    if (url === void 0) { url = ''; }
    if (data === void 0) { data = {}; }
    var xhr = new XMLHttpRequest();
    xhr.open('post', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    // TODO 暂时不进行错误处理
    xhr.onreadystatechange = function () { };
    xhr.send(JSON.stringify(data));
}

// 由于后端只会部署测试以及生产两套环境，因此非生产环境的都对应到测试环境地址
var env = (window.XCConfig ? window.XCConfig.VUE_APP_ENV : process.env.VUE_APP_ENV);
if (env !== 'prod') {
    env = 'test';
}
var PROD_URL = 'https://ser-cloud.xinchao.com/portal/xc-statistics/statistics/page';
var apiUrl;
try {
    apiUrl = getUrlByENV(PROD_URL, env);
}
catch (e) {
    // 默认到测试环境，确保不影响正常业务
    apiUrl = getUrlByENV(PROD_URL, 'test');
    console.warn("getUrlByENV('".concat(window.XCConfig ? window.XCConfig.VUE_APP_ENV : process.env.VUE_APP_ENV, "') \u5931\u8D25"), e);
}
function pushEvent(event) {
    return __awaiter(this, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = [event];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, sendByXhr(apiUrl, data)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    // TODO 增加重试机制
                    console.warn('埋点信息上报失败');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function pushPvEvent(config) {
    return __awaiter(this, void 0, void 0, function () {
        var clientId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getClientId()];
                case 1:
                    clientId = _a.sent();
                    return [4 /*yield*/, pushEvent({
                            clientId: clientId,
                            type: 'browser',
                            platform: 'web',
                            env: config.env || '',
                            productCode: config.productCode,
                            productVersion: config.productVersion,
                            pageName: config.pageName || '',
                            pagePath: window.location.href
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
// 对于使用 PUMA 脚手架的项目（或者其他使用 vue-cli 生成的项目）
// 通过参数 rootElement 找到 vue 挂载的 dom 元素，通过 __vue__ 属性，在 $router 上绑定
// 钩子方法，在切换路由时自动调用统计方法
function traceInitVue(rootElement, config, delayCount) {
    if (rootElement === void 0) { rootElement = 'app'; }
    if (delayCount === void 0) { delayCount = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var rootEl;
        return __generator(this, function (_a) {
            if (typeof rootElement === 'string') {
                rootEl = document.getElementById(rootElement);
                if (typeof (rootEl === null || rootEl === void 0 ? void 0 : rootEl.__vue__) === 'undefined') {
                    if (delayCount < 5) {
                        delayCount += 1;
                        setTimeout(function () {
                            traceInitVue(rootElement, config, delayCount);
                        }, 1000);
                    }
                    console.warn("vue rootElement ".concat(rootElement, " is not found"));
                    return [2 /*return*/];
                }
            }
            else {
                rootEl = rootElement;
                if (!(rootEl instanceof HTMLElement)) {
                    console.warn("vue rootElement ".concat(rootElement, " is not a HTMLElement"));
                    return [2 /*return*/];
                }
                if (typeof rootEl['__vue__'] === 'undefined') {
                    if (delayCount < 5) {
                        delayCount += 1;
                        setTimeout(function () {
                            traceInitVue(rootElement, config, delayCount);
                        }, 1000);
                    }
                }
                console.warn("vue rootElement ".concat(rootElement, " is not a vue component"));
                return [2 /*return*/];
            }
            // 断言 rootEl.__vue__ 存在，且为 Vue 实例
            rootEl.__vue__.$router.afterEach(function (to) {
                setTimeout(function () {
                    var _a;
                    var title = (_a = to === null || to === void 0 ? void 0 : to.meta) === null || _a === void 0 ? void 0 : _a.title;
                    if (title) {
                        config.pageName = title;
                    }
                    pushPvEvent(config);
                });
            });
            pushPvEvent(config);
            return [2 /*return*/];
        });
    });
}

export { pushEvent, pushPvEvent, traceInitVue };
//# sourceMappingURL=index.js.map
